import { Button } from '@/components/Button'
import { Note } from '@/components/Note'
import { GridTable } from '@/components/GridTable'
import { unitId } from '@/annotations'

const COLUMNS = ['Actor', 'Action', 'Object', 'IP address', 'Result', 'Occurred']

/**
 * `v-auditbb` — process/09-SCREEN-SPECS/v-auditbb.md. **Deliberately unbuilt behind the data**:
 * `NO_OPERATION`, and all six columns resolve to no field, recorded against `NG-69` (Bitbucket
 * audit-log ingestion is deferred) rather than left as an unmapped gap. This screen states that
 * plainly rather than rendering an empty table that could be misread as *no events*.
 */
export function VAuditbb() {
  return (
    <div data-scr={unitId('v-auditbb')}>
      <div data-cmp="panel-header" className="flex items-center gap-5 mb-6">
        <h1 className="m-0 text-section font-semibold flex-1">Bitbucket audit logs</h1>
        <Button data-act={undefined} ghost disabled title="Bitbucket audit-log ingestion is not built yet (NG-69)">
          Export CSV
        </Button>
      </div>
      <Note>Bitbucket's own audit log is not yet ingested by this product (NG-69). Nothing below is real data.</Note>
      <div className="mt-6">
        <GridTable
          columns={COLUMNS.map((c) => ({ key: c, header: c, render: () => null }))}
          rows={[]}
          getRowKey={() => ''}
          emptyMessage="Not yet ingested."
        />
      </div>
    </div>
  )
}
